<template>
    <div class="checkPay">
        <van-dialog
            v-model="showDailog"
            title="请确认微信支付是否已完成"
            :show-confirm-button=false
            :show-cancel-button=false
            >
            <div  class="checkPay-dialog-orderInfo">
                  <van-cell title-class='checkPay-dialog-text' title="购买号" :value="serialNumber" />
                  <van-cell title-class="checkPay-dialog-text" title="订单号" :value="orderCode" />
            </div>
            <div class="checkPay-dialog-content">
                <div class="checkPay-dialog-content-cell checkPay-dialog-content-cell-sure" @click="qryChoiceNumberOrderByOrderCode(false)">我已完成支付</div>
                <div class="checkPay-dialog-content-cell checkPay-dialog-content-cell-continue"  @click="qryChoiceNumberOrderByOrderCode(true)">支付遇到问题,重新支付</div>
                <div class="checkPay-dialog-content-cell checkPay-dialog-content-cell-continue"  @click="goIndex()">返回首页</div>            
            </div>
        </van-dialog>
    </div>
</template>
<script>
  import {setAesString,getAesString} from "../../config/date";
export default {
    data(){
        return{
            showDailog:false,
            serialNumber:'',
            orderCode:''
        }
    },
    created(){
        this.orderCode = this.$route.query.od;
        this.serialNumber = this.$route.query.num;
        if(this.orderCode == null || this.orderCode == ''
        || this.serialNumber == null || this.serialNumber == ''){
            this.$dialog.alert({
                message: '支付信息获取失败!'
            }).then(() => {
                //提交数据
                this.$router.push({
                    path:'/index'
                });
            });
            return;
        }
        this.orderCode = getAesString(this.orderCode);
        this.serialNumber = getAesString(this.serialNumber);
        if(this.orderCode == null || this.orderCode == ''
        || this.serialNumber == null || this.serialNumber == ''){
            this.$dialog.alert({
                message: '支付信息获取失败!'
            }).then(() => {
                //提交数据
                this.$router.push({
                    path:'/index'
                });
            });
            return;
        }
        this.showDailog = true;
    },
    methods:{
        goIndex(){
            this.$router.push({
                path:'/index'
            });
        },
        //查询订单
        qryChoiceNumberOrderByOrderCode(isPay){
            var formdata = {
                service:'user.qryChoiceNumberOrderByOrderCode',
                orderCode:this.orderCode,
            }
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                if(res.canPay){//未支付
                    if(!isPay){//未支付确点击已完成支付
                        this.$toast.fail("您的订单未支付,请先进行支付!");
                        return;
                    }
                    sessionStorage.setItem(setAesString("orderInfo"),setAesString(JSON.stringify(res)));
                    sessionStorage.setItem(setAesString("continuePay"),setAesString('true'));
                    this.$router.push({
                        path:'/needPayInfo'
                    });
                }else{//已支付
                    this.$toast.fail("支付成功,正在返回首页...");
                    this.$router.push({
                        path:'/index'
                    });
                }
            },(res)=>{
                this.$toast.fail(res.errorMsg);
            });
        }
    }
}
</script>
<style lang="less" scoped>
.van-cell__title{
    -webkit-box-flex: 0;
    -webkit-flex: 1;
    flex: 0.2 !important;
} .van-cell__value {
    -webkit-box-flex: 0;
    -webkit-flex: 1;
    flex: 0.8 !important;
}
.checkPay{
    &-dialog{
        &-orderInfo{
            margin: 20px 0px;
        }
        &-text{
            text-align: left;
            width:20px !important;
            color: #25C973;
        }
        &-content{
            margin: 10px 0px;
            text-align: center;
            &-cell{
                border-top: 0.5px solid rgb(177, 177, 177);
                &-sure{
                    padding: 10px 0px;
                    color: red;
                    font-size: 18px;
                }
                &-continue{
                    padding: 10px 0px;
                    color: gray;
                    font-size: 14px;
                }
            }
        }
    }
}

</style>